import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule, CdkDragEnd } from '@angular/cdk/drag-drop';
import { COMMON_SVG_IMG_PATH } from 'src/app/shared/common.constant';
import { selectUserName } from 'src/app/store/user/user.selectors';
import { Store } from '@ngrx/store';
import { MY_PROFILE, PROFILE } from 'src/app/shared/routeLink.constant';
import { Router } from '@angular/router';
import { REVOKE_IMPERSONATE } from 'src/app/shared/api.constant';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonService } from 'src/app/shared/service/common.service';
import { LoginService } from 'src/app/shared/service/login.service';
import { RoleService } from 'src/app/shared/service/role.service';
import { loginSuccess } from 'src/app/store/user/user.actions';
import { LoadingService } from '../../services/loading.service';
import { SsoService } from '../../services/sso.service';
import { TooltipModule } from 'primeng/tooltip';
import {
  setAllCountries,
  setPersistedAppContext,
} from 'src/app/store/appContext/app-context.actions';

@Component({
  selector: 'app-draggable-widget',
  standalone: true,
  imports: [CommonModule, DragDropModule, TooltipModule],
  templateUrl: './draggable-widget.component.html',
  styleUrls: ['./draggable-widget.component.scss'],
})
export class DraggableWidgetComponent implements OnInit, AfterViewInit {
  @ViewChild('widget', { static: true }) widgetRef!: ElementRef;

  svgPath: string = COMMON_SVG_IMG_PATH;
  impersonateName = '';

  position = { x: 0, y: 0 };

  constructor(
    private readonly store: Store,
    private readonly router: Router,
    public loadingService: LoadingService,
    private readonly ssoService: SsoService,
    private readonly commonService: CommonService,
    private readonly roleService: RoleService,
    private readonly loginService: LoginService
  ) {}

  ngOnInit(): void {
    const saved = localStorage.getItem('widgetPosition');
    if (saved) {
      this.position = JSON.parse(saved);
    }

    this.store.select(selectUserName).subscribe((name) => {
      this.impersonateName = name ?? '-';
    });
  }

  ngAfterViewInit(): void {
    if (!localStorage.getItem('widgetPosition')) {
      this.setDefaultCenterPosition();
    }
  }

  setDefaultCenterPosition() {
    const element = this.widgetRef.nativeElement;

    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    const elementWidth = element.offsetWidth;
    const elementHeight = element.offsetHeight;

    const x = (screenWidth - elementWidth) / 2;
    const y = screenHeight - elementHeight - 20; //

    this.position = { x, y };
  }

  onDragEnd(event: CdkDragEnd) {
    this.position = event.source.getFreeDragPosition();
    localStorage.setItem('widgetPosition', JSON.stringify(this.position));
  }

  switchAcc() {
    this.router.navigate([`/${PROFILE}/${MY_PROFILE}/switch-account`]);
  }

  originalUser() {
    this.ssoService.get(`${REVOKE_IMPERSONATE}`).subscribe({
      next: (result: any) => this.handleSignInSuccess(result?.data?.response),
      error: (error: HttpErrorResponse) => this.handleSignInError(error),
    });
  }

  private handleSignInError(error: HttpErrorResponse): void {
    this.loadingService.hide();
    // this.messages = [{ severity: 'warn', summary: error.error?.data?.message }];
  }

  private handleSignInSuccess(result: any): void {
    const setTokenUser = {
      token: result.accessToken,
      refreshToken: result.refreshToken,
      impersonate: false,
    };
    this.setLocalStorageData(setTokenUser);
    window.dispatchEvent(new Event('storage'));
    this.processToken(result);
  }

  setLocalStorageData(objData: any) {
    Object.entries(objData).forEach(([key, value]) => {
      this.commonService.setlocalStorageItem(key, value as string);
    });
  }

  private processToken(res: any): void {
    this.loginService.loginSSO(res).subscribe({
      next: (ele) => this.handleLoginSSOSuccess(ele, res.accessToken),
      // error: () => this.handleLoginSSOError(),
    });
  }

  private handleLoginSSOSuccess(ele: any, token: string): void {
    const setTokenUser = {
      token: token,
    };
    this.setLocalStorageData(setTokenUser);

    if (ele?.data?.response) {
      const data = ele.data.response;
      this.store.dispatch(
        setAllCountries({
          allCountries: data.availableCountries ?? [],
        })
      );
      this.store.dispatch(
        setPersistedAppContext({
          selectedCountry: data.availableCountries[0],
          originalUser: data.displayName ?? '',
          originalRole: data.roleName ?? '',
          isSuperAdmin: data.superAdmin ?? 'N',
        })
      );

      localStorage.setItem('originalToken', token ?? '');
      this.store.dispatch(
        loginSuccess({
          user: {
            name: data.displayName,
            email: data.email,
            phone: data.phoneNumber,
            roleName: data.roleName,
            roleCode: data.roleCode,
            uuid: data.uuid,
            vehicleTypes: data.vehicleTypeMap,
          },
        })
      );
    } else {
      this.handleInvalidResponse(ele);
    }
    this.roleService.initializeRoleFromStorage();
    window.location.reload();
  }

  private handleInvalidResponse(ele: any): void {
    this.loadingService.hide();

    // this.loading = false;
    // this.messages = [{ severity: 'warn', summary: ele.data.message }];
    // this.signOutAndRedirect();
  }
}
